<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		:class="iconColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_6084_13301)">
			<path
				d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM16 18H8V17.43C8 16.62 8.48 15.9 9.22 15.58C10.07 15.21 11.01 15 12 15C12.99 15 13.93 15.21 14.78 15.58C15.52 15.9 16 16.62 16 17.43V18Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_6084_13301">
				<rect
					width="24"
					height="24"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>
<script setup>
const props = defineProps({
	iconColor:{
		type:String,
		default:'#2A8176'
	}
}
);
</script>
 
